import { useLayoutEffect } from 'react';

let locks = 0;
let restorePage: (() => void) | undefined;

// Resource handlers can overlap. Only the first lock owns the page state,
// and only the last release may restore it.
export default function useResourceModalPageLock(active: boolean, originScrollPosition?: number) {
  useLayoutEffect(() => {
    if (!active) return;

    if (locks === 0) {
      const previousOverflow = document.body.style.overflow;
      const pathname = window.location.pathname;
      const scrollX = window.scrollX;
      const scrollY = originScrollPosition ?? window.scrollY;
      const opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      document.body.style.overflow = 'hidden';

      restorePage = () => {
        document.body.style.overflow = previousOverflow;
        // A different page owns its own initial scroll/focus position.
        if (window.location.pathname !== pathname) return;
        if (opener?.isConnected) opener.focus({ preventScroll: true });
        if (window.scrollX !== scrollX || window.scrollY !== scrollY) {
          window.scrollTo(scrollX, scrollY);
        }
      };
    }
    locks += 1;

    return () => {
      locks -= 1;
      if (locks === 0) {
        restorePage?.();
        restorePage = undefined;
      }
    };
  }, [active, originScrollPosition]);
}
